import { InputAdornment, TextField } from '@mui/material';

import SearchIcon from '@/components/Icons/SearchIcon';

import { SearchProps } from './types';

function Search({ query, setQuery, placeholder = 'Find by name or ID' }: SearchProps) {
  return (
    <TextField
      placeholder={placeholder}
      value={query}
      sx={{ maxWidth: 400, flex: 1, minWidth: 150 }}
      onChange={(e) => setQuery(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />
  );
}

export default Search;
